/* FALO - email obfuscation.
 *
 * snippets/falo-email-link.liquid emits the local part and the domain into
 * two separate data attributes, so the served HTML contains no "@" and no
 * "mailto:" for the address. This script joins them back together into a
 * real mailto: link at runtime, which is what mass address harvesters -
 * which do not execute JavaScript - never see.
 *
 * Loaded once per page from sections/falo-footer.liquid.
 */
(function () {
  'use strict';

  function reveal(link) {
    if (link.getAttribute('data-falo-email') === 'done') return;

    var user = link.getAttribute('data-u') || '';
    var domain = link.getAttribute('data-d') || '';
    if (!user || !domain || domain.indexOf('.') === -1) return;

    var address = user + String.fromCharCode(64) + domain;

    link.setAttribute('href', 'mailto:' + address);
    if (link.getAttribute('data-keep-label') !== '1') {
      link.textContent = address;
    }
    link.removeAttribute('data-u');
    link.removeAttribute('data-d');
    link.setAttribute('data-falo-email', 'done');
  }

  function init(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[data-falo-email]');
    Array.prototype.forEach.call(links, reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor swaps sections in without a full page reload.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
